import { render } from "./terms_of_service_panel.vue?vue&type=template&id=22763f84"
import script from "./terms_of_service_panel.js?vue&type=script&lang=js"
export * from "./terms_of_service_panel.js?vue&type=script&lang=js"

import "./terms_of_service_panel.vue?vue&type=style&index=0&id=22763f84&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__